<template>
  <div id="factfield-app">
    <Login v-if="dev" class="debug-login" />
    <!--<transition name="fade" mode="out-in">-->
    <router-view />
    <!--</transition>-->
    <portal-target name="a11y-vue-dialogs-main" multiple />
  </div>
</template>

<script>
import Vue from "vue";
import VueGtag from "vue-gtag";

import store from "@/store";
import router from "@/router";

import configureVue from "@/services/vue_config";
configureVue();

Vue.use(
  VueGtag,
  {
    config: { id: "UA-123456789-0" },
    appName: "Factfield - Benchmarking",
    pageTrackerScreenviewEnabled: true,
  },
  router
);

Vue.mixin({ router, store });

window.addEventListener("auth-from-icon", () => {
  //onsole.log("auth event received in main app");
  store.dispatch("auth/refresh");
});

export default {
  name: "App",
  components: { Login: () => import("./Login") },
  computed: {
    dev() {
      return process.env.NODE_ENV !== "production";
    },
  },
  data() {
    return {
      loginOpen: false,
    };
  },
};
</script>
<style lang="postcss">
@import "../styles/global.css";
@import "../styles/buttons.css";

.debug-login {
  @apply absolute right-0 top-0 z-50;

  svg {
    @apply absolute right-0 top-0;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
/*! purgecss start ignore */

.tooltip {
  @apply block z-50 ml-4;
}

.tooltip-inner {
  @apply bg-primary-bright text-white p-8 -mt-4 max-w-3/4;
  clip-path: polygon(0% 5%, 100% 0%, 100% 100%, 0% 95%);

  @screen md {
    @apply mt-0;
    max-width: 25vw;
  }
}

.tooltip-arrow {
  @apply hidden;
}

/*! purgecss end ignore */
</style>
